<script>
import { ref, onBeforeMount, computed } from 'vue'
import { useRestoGLobalStore } from '@/stores/restoGlobalStore'
import { useFeatureFlagsStore } from '@/stores/featureFlagsStore'
import { useAuthGlobalStore } from '@/stores/authGlobalStore'
import StripePaymentElement from './StripePaymentElement.vue'
import StripeCardPayment from './StripeCardPayment.vue'

export default {
  components: {
    StripePaymentElement,
    StripeCardPayment
  },

  props: {
    beforePlaceOrder: {
      type: Function,
      default: null
    }
  },

  setup(props, { expose }) {
    const restoStore = useRestoGLobalStore()
    const featureFlagsStore = useFeatureFlagsStore()
    const authStore = useAuthGlobalStore()

    const isLoaded = ref(false)
    const childRef = ref(null)

    const showStripePaymentElement = computed(() => {
      return featureFlagsStore.isApplePayEnabled(restoStore?.RESTO_ID, authStore?.user?.customer_id)
    })

    const payButtonDisabled = computed(() => {
      return childRef.value?.payButtonDisabled !== false
    })

    const handleStripePayment = () => {
      childRef.value?.handleStripePayment?.()
    }

    onBeforeMount(() => {
      isLoaded.value = true
    })

    expose({
      handleStripePayment,
      payButtonDisabled
    })

    return {
      isLoaded,
      showStripePaymentElement,
      childRef,
      beforePlaceOrder: props.beforePlaceOrder,
      handleStripePayment,
      payButtonDisabled
    }
  }
}
</script>

<template>
  <div v-if="isLoaded" class="card-payment-gateway">
    <StripePaymentElement
      v-if="showStripePaymentElement"
      ref="childRef"
      :before-place-order="beforePlaceOrder"
    />
    <StripeCardPayment v-else ref="childRef" :before-place-order="beforePlaceOrder" />
  </div>
  <div v-else class="p-4 text-center text-gray-500 dark:text-gray-400">Loading payment details...</div>
</template>
